import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon  } from 'mdbreact';
import { MDBBreadcrumb, MDBBreadcrumbItem } from "mdbreact";
import {  MDBTabPane, MDBTabContent, MDBNav, MDBNavItem, MDBNavLink } from "mdbreact";
import Axios from 'axios'
import { Steps, Alert  } from 'antd';
import Modalarticlefaculty from './Modalarticlefaculty';
import Modalsentedit from './Modalsentedit';
import Modalsuccess from './Modalsuccess';
import axios from 'axios';

export default class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
         
            article2:[],

            activeItem: "1",
            admin_faculty:"",
        };
      //   this.selectarticlefaculty = this.selectarticlefaculty.bind(this);
        //  this.selectatf = this.selectatf.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
        // this.updateat = this.updateat.bind(this);
      }



      componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        // if (localStorage.getItem('nameuser') == null) {
        //     window.location.href = '/'
        // } else {
        //     this.setState({ admin_faculty:localStorage.getItem('admin_faculty')})
        // }

        // axios.get(`https://kpruinnovation.kpru.ac.th/api/teacher/SelectTeacherreport`,
        // {headers: {
        //     //Authorization: 'Bearer ' + localStorage.getItem('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2MTQ5MzgzMjgsImV4cCI6MTYxNTE1NDMyOCwidXNlcmlkIjpudWxsfQ.nmTzf07-cu1RaUZjW4QvdU5gy_9pqbwBtfm7J76J88A')
        //     Authorization: 'Bearer  eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2MTQ5Mzg1ODAsImV4cCI6MTYxNTE1NDU4MCwidXNlcmlkIjoiNTYyMDE5MDAzNDgzNyJ9.3q8EkUHBa2-KDFwZ86H7l6XPi2GOayiIxwR44Jnbfmg'
        //   }
        // })
        //   .then(res => {
        //    // const position_education = res.data;
        //    // this.setState({ position_education });
        //   })


        fetch('https://kpruinnovation.kpru.ac.th/api/teacher/SelectTeacherreport', {
  method: 'get',
  //body: JSON.stringify(user),
  headers: {
    Authorization: 'Bearer  eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2MTUwODA2MDgsImV4cCI6MTYxNTI5NjYwOCwidXNlcmlkIjoiNTYyMDE5MDAzNDgzNyJ9.a8hXPBl5EiZKwm_s8qY-Z04MUDo74FedTR1iMK7x9yA'
     }
   })
  .then(res => res.json())
  .then((res) => {
    localStorage.setItem('myData', res.data.token);
  })
  .catch(err => {
    console.log('request failed', err);
  })


        // setTimeout(() => {
        //    //ภายใน
        //     Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty.php?faculty='+localStorage.getItem('admin_faculty'))
        //    .then(res => {
        //      console.log(res);
        //    //  this.setState({ bankname: res.data, loading: false })
        //      this.setState({ articlesci1: res.data})
        //    }) 

         

        //  }, 0);
      }







      selectatf() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        // if (localStorage.getItem('nameuser') == null) {
        //     window.location.href = '/'
        // } else {
        //     this.setState({ admin_faculty:localStorage.getItem('admin_faculty')})
        // }

        setTimeout(() => {
           //ภายใน
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty.php?faculty='+localStorage.getItem('admin_faculty'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlesci1: res.data})
           }) 

  
         }, 0);
      }


 


    render() {
        return (
            <MDBContainer fluid>
            <div>
               

                {/* <p className="text-right"> (ผู้ดูแลระบบระดับคณะ)</p>
                <p className="text-right">ระบบบริหารจัดการเกรด มหาวิทยาลัยราชภัฏกำแพงเพชร</p> 

                { localStorage.getItem('admin_faculty') == 7 ? <><p className="text-right">มรภ.กพ แม่สอด</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 6 ? <><p className="text-right">คณะพยาบาลศาสตร์</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 5 ? <><p className="text-right">คณะเทคโนโลยีอุตสาหกรรม</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 4 ? <><p className="text-right">คณะวิทยาการจัดการ</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 3 ? <><p className="text-right">คณะมนุษยศาสตร์และสังคมศาสตร์</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 2 ? <><p className="text-right">คณะวิทยาศาสตร์และเทคโนโลยี</p></>:<></>}
                { localStorage.getItem('admin_faculty') == 1 ? <><p className="text-right">คณะครุศาสตร์</p></>:<></>} */}

            

                {/* <Alert message={"บทความภายใน สาขาวิทยาศาสตร์และเทคโนโลยี จำนวน "+ this.state.articlesci1.length+" บทความ"} type="info" /> */}
                <MDBBreadcrumb>
        <MDBBreadcrumbItem active>ค้นหา</MDBBreadcrumbItem>
      </MDBBreadcrumb>

            </div>
            </MDBContainer>

        )
    }
}
